import React from 'react';
import { motion } from 'framer-motion';
import { ArrowDown } from 'lucide-react';
export function HeroSection() {
  return <section className="relative min-h-[90vh] flex flex-col justify-center bg-gradient-elegant pt-20 pb-16 px-4 sm:px-6 lg:px-8 overflow-hidden" data-id="element-84">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden -z-10" data-id="element-85">
        <div className="absolute top-[-10%] right-[-5%] w-96 h-96 bg-blush-200 rounded-full mix-blend-multiply filter blur-3xl opacity-50 animate-blob" data-id="element-86"></div>
        <div className="absolute bottom-[-10%] left-[-10%] w-72 h-72 bg-gold-400 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-blob animation-delay-2000" data-id="element-87"></div>
      </div>

      <div className="max-w-7xl mx-auto w-full" data-id="element-88">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-89">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="flex flex-col space-y-6 text-center lg:text-left z-10" data-id="element-90">
            <div className="inline-flex items-center justify-center lg:justify-start space-x-2" data-id="element-91">
              <span className="px-4 py-1.5 rounded-full bg-emerald-900/10 text-emerald-900 text-sm font-bold tracking-wider uppercase border border-emerald-900/20" data-id="element-92">
                MÉTODO 3-3-3: EMPRENDIMIENTO EXPRESS
              </span>
            </div>

            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-black text-ink-900 leading-[1.1] text-balance" data-id="element-93">
              ¿Y SI TE DIJERA QUE PUEDES GANAR{' '}
              <span className="text-emerald-900 italic" data-id="element-94">CÓMODAMENTE $300</span>{' '}
              ESTA SEMANA...
            </h1>

            <h2 className="text-2xl sm:text-3xl font-serif text-ink-800 leading-snug" data-id="element-95">
              ...Con Solo $50, 3 Tiendas y 3 Horas de Tu Tiempo?
            </h2>

            <p className="text-lg sm:text-xl text-ink-800/80 font-medium" data-id="element-96">
              Sin máquinas. Sin inventario enorme. Sin experiencia previa.
            </p>

            <div className="pt-8 flex flex-col items-center lg:items-start space-y-4" data-id="element-97">
              <motion.button onClick={() => {
              document.getElementById('pricing-card')?.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
              });
            }} whileHover={{
              scale: 1.02
            }} whileTap={{
              scale: 0.98
            }} className="w-full sm:w-auto px-8 py-4 bg-emerald-900 text-white rounded-none text-lg font-bold shadow-xl hover:bg-emerald-800 transition-colors flex items-center justify-center space-x-2 group cursor-pointer" data-id="element-98">
                <span data-id="element-99">SÍ, QUIERO EMPEZAR HOY</span>
                <ArrowDown className="w-5 h-5 group-hover:translate-y-1 transition-transform" data-id="element-100" />
              </motion.button>
              <p className="text-sm text-ink-800/60 font-medium flex items-center" data-id="element-101">
                <span className="mr-2" data-id="element-102">🌸</span> Especial Día de la Madre
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 1,
          delay: 0.2,
          ease: 'easeOut'
        }} className="relative z-10" data-id="element-103">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl shadow-ink-900/10 border-8 border-white transform lg:rotate-2 hover:rotate-0 transition-transform duration-500" data-id="element-104">
              <img src="https://cdn.magicpatterns.com/uploads/nfj1yyeanb5wX3pupegsAb/heylloyd-image-1774136192901.png" alt="Mujer emprendedora mostrando elegantes cajas de regalo color rosa con listones de terciopelo verde esmeralda" className="w-full h-auto object-cover" data-id="element-105" />
              <div className="absolute inset-0 bg-gradient-to-t from-ink-900/20 to-transparent mix-blend-overlay" data-id="element-106"></div>
            </div>

            {/* Floating badge */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.8
          }} className="absolute -bottom-6 -left-6 bg-white p-4 rounded-xl shadow-xl border border-blush-100 max-w-xs hidden sm:block" data-id="element-107">
              <p className="text-sm font-bold text-ink-900" data-id="element-108">
                "Transforma $15 en $45 en menos de 20 minutos."
              </p>
              <div className="flex text-gold-500 mt-1" data-id="element-109">
                {'★★★★★'.split('').map((star, i) => <span key={i} data-id="element-110">{star}</span>)}
              </div>
            </motion.div>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 1.2,
        duration: 1
      }} className="mt-24 text-center pb-8" data-id="element-111">
          <p className="text-ink-800 font-serif italic text-xl max-w-2xl mx-auto" data-id="element-112">
            👇 Sigue leyendo. Lo que estás a punto de descubrir va a cambiar tu
            Mayo para siempre.
          </p>
          <motion.div animate={{
          y: [0, 10, 0]
        }} transition={{
          repeat: Infinity,
          duration: 2
        }} className="mt-4 flex justify-center" data-id="element-113">
            <ArrowDown className="text-gold-500 w-6 h-6 opacity-70" data-id="element-114" />
          </motion.div>
        </motion.div>
      </div>
    </section>;
}